var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.row.item.Status === 'Pending')?_c('span',[_c('b-badge',{attrs:{"variant":"secondary"}},[_vm._v(_vm._s(_vm.row.item.Status))])],1):_vm._e(),(_vm.row.item.Status === 'Resolved')?_c('span',[_c('b-badge',{attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.row.item.Status))])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }